<article>
  <header>
    <strong>Transcrições no Período</strong>
  </header>
  <main>
    <app-bar-chart [loading]="isLoading" [error]="error"></app-bar-chart>
  </main>
</article>
